import { Outlet } from '@tanstack/react-router';
import { GuideLinkButton, PageLayout, useBreadcrumbs, useTabs } from '@mews-commander/ui';
import { compactArray } from '@mews/fp';
import { ArticlePath, createGuideLink } from '@mews-commander/enums';
import { useIsCreditNoteCountersEnabled } from '../utils';
import { EditCounterDialog } from './EditCounterDialog';

export const CountersPageLayout = () => {
    const breadcrumbs = useBreadcrumbs();

    const isCreditNoteEnabled = useIsCreditNoteCountersEnabled();
    const tabs = useTabs(
        '/$currentEnterpriseId/Settings/Counters',
        compactArray(['Bill', isCreditNoteEnabled ? 'CreditNote' : null, 'Proforma', 'Preview', 'SystemGenerated'])
    );

    const actions = <GuideLinkButton guideLink={createGuideLink(ArticlePath.BillInvoiceNumberingWithCounters)} />;

    return (
        <PageLayout padded breadcrumbs={breadcrumbs} tabs={tabs} actions={actions}>
            <Outlet />
            <EditCounterDialog />
        </PageLayout>
    );
};
